import { useState, useEffect } from "react";

import {
    Button
} from "react-bootstrap";

import {
    useDispatch
} from "react-redux";

import {
    updateConf,
    deleteConf
} from "./store/companyConfSlice";

import "./App.css";

export default function CompanyConfRow(props) {
    const dispatch = useDispatch();

    const [rowKey, setRowKey] = useState("");
    const [rowValue, setRowValue] = useState("");

    const onTextChange = (e, txtField) => {
        const val = e.target.value;

        let conf = {
            keyIndex: props.keyIndex,
            key: rowKey,
            value: rowValue
        };

        if (txtField === "KEY") {
            conf = {
                ...conf,
                key: val
            };

            setRowKey(val);
        } else if (txtField === "VALUE") {
            conf = {
                ...conf,
                value: val
            };

            setRowValue(val);
        }
        
        dispatch(updateConf(conf));
    };

    const onDelete = () => {
        dispatch(deleteConf(props.keyIndex));
    };

    useEffect(() => {
        const {
            key,
            value
        } = props.initialData;

        setRowKey(key);
        setRowValue(value);
    }, [props.initialData]);
    
    return (
        <tr className="tbody-row">
            <td className="tbody-cell"><input type="text" value={ rowKey } onChange={(e) => { onTextChange(e, "KEY") }} /></td>
            <td className="tbody-cell"><input type="text" value={ rowValue } onChange={(e) => { onTextChange(e, "VALUE") }} /></td>
            <td className="tbody-cell tbody-cell-centered">
                <Button variant="danger" onClick={ onDelete }><img src="img/remove_circle_white_36dp.svg" /></Button>
            </td>
        </tr>
    );
}